import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { useNavigate } from 'react-router-dom'
import { PAGE_FRESH_CATEGORY_UPDATE } from 'utils/constants'

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
  getCategoryToDelete: (params: ICellRendererParams) => void
}

const ActionCellRenderer = ({
  params,
  isEditor,
  getCategoryToDelete,
}: ActionCellRendererProps) => {
  const navigate = useNavigate()

  if (!isEditor) return <></>

  return (
    <div className="flex h-full items-center justify-center gap-3">
      <Button
        size="small"
        variant="outline"
        className="w-20"
        buttonText="Edit"
        type="button"
        onClick={() =>
          navigate(`${PAGE_FRESH_CATEGORY_UPDATE.path}/${params.data._id}`)
        }
      />
      <Button
        size="small"
        className="w-20"
        buttonText="Delete"
        type="button"
        onClick={() => getCategoryToDelete(params)}
      />
    </div>
  )
}

export default ActionCellRenderer
